module.exports = __webpack_public_path__ + "static/media/logo.fda2eb7b.png";